export const createFileInfoState = () => ({
    byId: {},
    allIds: []
});
export const createFileUploadProgressState = () => ({
    byId: {},
    allIds: []
});
export const createFileUploadSuccessState = () => ({
    byId: {},
    allIds: []
});
export const createFileUploadModalState = () => ({ isOpen: false });
export const createFileUploadMaxSizeState = () => ({ maxVideoFileSize: undefined });
export const createFileState = () => ({
    fileUploadProgress: createFileUploadProgressState(),
    fileUploadSuccess: createFileUploadSuccessState(),
    fileUploadModal: createFileUploadModalState(),
    fileInfo: createFileInfoState(),
    fileUploadMaxSize: createFileUploadMaxSizeState()
});
//# sourceMappingURL=fileInstanceCreator.js.map